export default "__VITE_ASSET__3cac6d9e__"